import { render, staticRenderFns } from "./assignRole.vue?vue&type=template&id=67820a80&scoped=true"
import script from "./assignRole.vue?vue&type=script&lang=js"
export * from "./assignRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67820a80",
  null
  
)

export default component.exports